import { useFetch } from '@/composables'
import type { FetchListDataParams, RequestParams } from '@/types'

export const useFetchListData = <R = unknown, T = R, P = RequestParams>({
  url,
  transform,
  initialData,
  params = {} as P,
  method = 'POST',
  debounceTime = 0,
  errorMessage = '请求出错',
  showErrorMessage,
  autoFetch = true,
  onSuccess,
  onComplete,
  onFailure,
}: FetchListDataParams<R, T, P>) => {
  // 使用类型断言确保与 R 匹配
  const effectiveInitialData = (initialData ?? []) as R

  const { loading, data, queryParams, fetchData } = useFetch<R, T, P>({
    url,
    transform,
    // 传递经过类型断言的初始数据
    initialData: effectiveInitialData,
    params,
    method,
    debounceTime,
    errorMessage,
    showErrorMessage,
    autoFetch,
    onSuccess,
    onComplete,
    onFailure,
  })

  return {
    loading,
    data,
    queryParams,
    fetchData,
  }
}
